import { useContext } from "react";
import PaymentIDsContext from "../Context/PaymentIDsProvider";

const usePaymentIDs = () => {
    return useContext(PaymentIDsContext)
}

export default usePaymentIDs;